export default __webpack_public_path__ + "static/media/mallory_compact_light.3fbfc945.ttf";